import { Component, OnInit, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators/switchMap';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { CorrelationService } from '@wdpr/ra-angular-correlation';

import { UrlParamsService } from '@finder/shared/services/url-params/url-params.service';

@Component({
    selector: 'finder-debug-panel',
    templateUrl: './debug-panel.component.html',
    styleUrls: ['./debug-panel.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
})
export class DebugPanelComponent implements OnInit, OnDestroy {
    @Input() svcResponse;
    pageType: string;
    entityId: string;
    entityType: string;
    location: string;
    urlFriendly: string;
    destroy$ = new Subject<void>();
    showEditor = false;
    showPanel = true;
    conversationUUID: string;

    constructor(
        private route: ActivatedRoute,
        private urlParamsService: UrlParamsService,
        private correlationService: CorrelationService,
    ) {}

    ngOnInit() {
        if (!this.svcResponse) {
            this.showPanel = false;
            return;
        }

        this.route.paramMap
            .pipe(
                switchMap((params: ParamMap) => {
                    this.urlParamsService.setParams(params);
                    this.entityType = this.urlParamsService.entityType;
                    this.location = this.urlParamsService.location;
                    this.urlFriendly = this.urlParamsService.id;
                    return this.route.data;
                }),
                takeUntil(this.destroy$)
            )
            .subscribe(data => {
                this.getDebugData(data);
            });
    }

    // Ignore the if just for coverage, there's no need to test unsubscribe
    /* istanbul ignore next */
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    getDebugData(data = this.route.snapshot.data) {
        const svc = this.svcResponse || data.svc;
        this.pageType = this.getPageType(data.pageType);
        this.entityId = svc.id;
        this.showEditor = svc ? true : false;
        this.conversationUUID = this.correlationService.getCookieData(
            this.correlationService.getConversationCookieName()
        );
    }

    // Since the detail and campaign pages get loaded by the dynamic loader
    // they always report as "dynamic" - this fixes that issue
    private getPageType(pageType)  {
        if (pageType !== 'dynamic') {
            return pageType;
        }

        if (this.svcResponse.isOverview) {
            pageType = 'overview';
        } else if (this.svcResponse.isCampaign === true) {
            pageType = 'campaign';
        } else {
            pageType = 'detail';
        }

        return pageType;
    }
}
